import type {LanguageSelectorTranslation} from '../languageSelectorTranslationType';

export const translation: LanguageSelectorTranslation = {
  nav: {
    homeAriaLabel: (ctx) => `Página inicial de chat anónimo do ${ctx.brand}`,
    languageButtonLabel: `Idioma`,
    languageModalTitle: `Escolhe um idioma`,
    languageModalCloseLabel: `Fechar menu de idiomas`,
  },
  languageOptions: {
    'en-US': {
      label: `Inglês (Estados Unidos)`,
      countryCodes: [`US`],
    },
    'en-KE': {
      label: `Inglês (Quénia)`,
      countryCodes: [`KE`],
    },
    'en-NG': {
      label: `Inglês (Nigéria)`,
      countryCodes: [`NG`],
    },
    'en-SG': {
      label: `Inglês (Singapura)`,
      countryCodes: [`SG`],
    },
    'pt-PT': {
      label: `Português (Portugal)`,
      countryCodes: [`PT`],
    },
    'pt-BR': {
      label: `Português (Brasil)`,
      countryCodes: [`BR`],
    },
    'de-DE': {
      label: `Alemão (Alemanha)`,
      countryCodes: [`DE`],
    },
    'de-AT': {
      label: `Alemão (Áustria)`,
      countryCodes: [`AT`],
    },
    'de-CH': {
      label: `Alemão (Suíça)`,
      countryCodes: [`CH`],
    },
    'es-ES': {
      label: `Espanhol (Espanha)`,
      countryCodes: [`ES`],
    },
    'fr-FR': {
      label: `Francês (França)`,
      countryCodes: [`FR`],
    },
    'it-IT': {
      label: `Italiano (Itália)`,
      countryCodes: [`IT`],
    },
    'nl-NL': {
      label: `Neerlandês (Países Baixos)`,
      countryCodes: [`NL`],
    },
    'pl-PL': {
      label: `Polaco (Polónia)`,
      countryCodes: [`PL`],
    },
    'sv-SE': {
      label: `Sueco (Suécia)`,
      countryCodes: [`SE`],
    },
    'da-DK': {
      label: `Dinamarquês (Dinamarca)`,
      countryCodes: [`DK`],
    },
    'fi-FI': {
      label: `Finlandês (Finlândia)`,
      countryCodes: [`FI`],
    },
    'no-NO': {
      label: `Norueguês (Noruega)`,
      countryCodes: [`NO`],
    },
    'is-IS': {
      label: `Islandês (Islândia)`,
      countryCodes: [`IS`],
    },
    'ja-JP': {
      label: `Japonês (Japão)`,
      countryCodes: [`JP`],
    },
    'ko-KR': {
      label: `Coreano (Coreia do Sul)`,
      countryCodes: [`KR`],
    },
    'zh-Hans-CN': {
      label: `Chinês (China)`,
      countryCodes: [`CN`],
    },
    'yue-Hant-HK': {
      label: `Cantonês (Hong Kong, RAE da China)`,
      countryCodes: [`HK`],
    },
    'vi-VN': {
      label: `Vietnamita (Vietname)`,
      countryCodes: [`VN`],
    },
    'th-TH': {
      label: `Tailandês (Tailândia)`,
      countryCodes: [`TH`],
    },
    'id-ID': {
      label: `Indonésio (Indonésia)`,
      countryCodes: [`ID`],
    },
    'sw-KE': {
      label: `Suaíli (Quénia)`,
      countryCodes: [`KE`],
    },
    'hi-IN': {
      label: `Hindi (Índia)`,
      countryCodes: [`IN`],
    },
    'bn-BD': {
      label: `Bengalês (Bangladeche)`,
      countryCodes: [`BD`],
    },
    'mr-IN': {
      label: `Marata (Índia)`,
      countryCodes: [`IN`],
    },
    'te-IN': {
      label: `Telugu (Índia)`,
      countryCodes: [`IN`],
    },
    'fa-IR': {
      label: `Persa (Irão)`,
      countryCodes: [`IR`],
    },
    'ur-PK': {
      label: `Urdu (Paquistão)`,
      countryCodes: [`PK`],
    },
    'pa-PK': {
      label: `Panjabi (Paquistão)`,
      countryCodes: [`PK`],
    },
    'pcm-NG': {
      label: `Pidgin nigeriano (Nigéria)`,
      countryCodes: [`NG`],
    },
    'ru-RU': {
      label: `Russo (Rússia)`,
      countryCodes: [`RU`],
    },
    'ar-SA': {
      label: `Árabe (Arábia Saudita)`,
      countryCodes: [`SA`],
    },
    'ar-AE': {
      label: `Árabe (Emirados Árabes Unidos)`,
      countryCodes: [`AE`],
    },
    'ar-QA': {
      label: `Árabe (Catar)`,
      countryCodes: [`QA`],
    },
    'ar-MA': {
      label: `Árabe marroquino (Marrocos)`,
      countryCodes: [`MA`],
    },
    'tr-TR': {
      label: `Turco (Turquia)`,
      countryCodes: [`TR`],
    },
  },
  languageModal: {
    title: `Escolhe um idioma`,
    closeLabel: `Fechar menu de idiomas`,
  },
  languageHint: (ctx) => `Explora ${ctx.localesCount}+ locais sem criar conta.`,
  readPagePrompt: ({languageLabel}) => `Lê esta página em ${languageLabel}.`,
};
